<template>
  <div class="kb-fault-case-edit">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" :content="pageTitle" />
    <ml-tip class="scroll-box" :showHeader="false" style="border: 0">
      <el-scrollbar :height="tabberHeight(185)">
        <!-- 表单 -->
        <ml-form
          ref="caseFormRef"
          labelWidth="160px"
          style="width: 900px; margin: 20px auto"
          :model="caseForm"
          :rules="caseFormRules"
        >
          <!-- ==================== 基础信息 ==================== -->
          <el-divider content-position="left" style="font-weight: bold">基础信息</el-divider>
          <el-row>
            <el-col :span="12">
              <ml-input
                prop="faultTitle"
                label="故障标题:"
                placeholder="请输入故障标题"
                v-model="caseForm.faultTitle"
              />
            </el-col>
            <el-col :span="12">
              <ml-select
                prop="firstClassify"
                placeholder="请选择一级分类"
                :options="classifyOptions"
                label="一级分类:"
                keyName="label"
                labelName="label"
                valueName="label"
                v-model="caseForm.firstClassify"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <ml-select
                prop="faultLevel"
                placeholder="请选择故障等级"
                :options="severityData"
                label="故障等级:"
                keyName="label"
                labelName="label"
                valueName="label"
                v-model="caseForm.faultLevel"
              />
            </el-col>
            <el-col :span="12">
              <ml-input
                prop="targetDevice"
                label="涉及设备/系统:"
                placeholder="请输入涉及设备/系统"
                v-model="caseForm.targetDevice"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <ml-date-picker
                prop="faultTime"
                placeholder="请选择故障发生时间"
                label="故障发生时间:"
                type="datetime"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="caseForm.faultTime"
              />
            </el-col>
            <el-col :span="12">
              <ml-input
                prop="customTags"
                label="自定义标签:"
                placeholder="多个标签逗号隔开"
                v-model="caseForm.customTags"
              />
            </el-col>
          </el-row>

          <!-- ==================== 背景与现象 ==================== -->
          <el-divider content-position="left" style="font-weight: bold">背景与现象</el-divider>
          <ml-input
            prop="preBackground"
            label="故障前置背景:"
            type="textarea"
            :rows="4"
            placeholder="故障前运行状态，近期变更，历史同类问题，前置告警记录"
            v-model="caseForm.preBackground"
          />
          <ml-input
            prop="scenePhenomenon"
            label="故障现场现象:"
            type="textarea"
            :rows="5"
            placeholder="完整描述异常，报错信息，指示灯，业务影响，停机时长，报错代码等，禁止只写设备异常"
            v-model="caseForm.scenePhenomenon"
          />
          <el-form-item label="上传截图/现场照片:">
            <ml-upload
              multiple
              autoUpload
              :showFileList="false"
              :action="uploadAction"
              :data="{ linkType: 'kbFaultCase' }"
              :headers="{ Authorization: token }"
              accept=".jpg,.jpeg,.png"
              name="files"
              @on-success="onImgSuccess"
            >
              <el-button size="medium" icon="el-icon-picture-outline" type="primary">
                上传截图/现场照片（jpg/png）
              </el-button>
            </ml-upload>
            <ml-list
              style="margin-top: 10px"
              fileName="fileName"
              :list="caseForm.imgUrlList"
              :showDelete="true"
            />
          </el-form-item>

          <!-- ==================== 排查处理过程 ==================== -->
          <el-divider content-position="left" style="font-weight: bold">排查处理过程</el-divider>
          <ml-input
            prop="checkThought"
            label="分步排查思路:"
            type="textarea"
            :rows="5"
            placeholder="按时间顺序记录排查操作，检测命令，排除项，判断依据"
            v-model="caseForm.checkThought"
          />
          <ml-input
            prop="handleOperation"
            label="最终处置操作:"
            type="textarea"
            :rows="5"
            placeholder="完整修复步骤，更换硬件，修改重置，重启服务，执行脚本等"
            v-model="caseForm.handleOperation"
          />

          <!-- ==================== 复盘与附件 ==================== -->
          <el-divider content-position="left" style="font-weight: bold">复盘与附件</el-divider>
          <ml-input
            prop="rootCause"
            label="故障根本原因:"
            type="textarea"
            :rows="4"
            placeholder="区分表面现象与根源，定位真实原因"
            v-model="caseForm.rootCause"
          />
          <ml-input
            prop="preventPlan"
            label="预防优化方案:"
            type="textarea"
            :rows="4"
            placeholder="如何规避同类故障，巡检规则，监控阀值，系统升级，操作规范"
            v-model="caseForm.preventPlan"
          />
          <el-form-item label="附件上传:">
            <ml-upload
              multiple
              autoUpload
              :showFileList="false"
              :action="uploadAction"
              :data="{ linkType: 'kbFaultCase' }"
              :headers="{ Authorization: token }"
              name="files"
              @on-success="onFileSuccess"
            >
              <el-button size="medium" icon="el-icon-folder-opened" type="primary">
                上传附件
              </el-button>
            </ml-upload>
            <ml-list
              style="margin-top: 10px"
              fileName="fileName"
              :list="caseForm.fileUrlList"
              :showDelete="true"
            />
          </el-form-item>

          <!-- 提交按钮 -->
          <ml-button
            submitText="提交入库"
            submitIcon="el-icon-upload2"
            submitType="primary"
            cancelText="保存草稿"
            cancelIcon="el-icon-document-add"
            cancelType="info"
            @click-submit="clickSubmit"
            @click-cancel="clickSaveDraft"
            style="margin-top: 20px"
          >
            <el-button size="medium" icon="el-icon-circle-close" @click="clickCancel">
              返回上一页
            </el-button>
          </ml-button>
        </ml-form>
      </el-scrollbar>
    </ml-tip>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { tabberHeight } from '@/utils'
import { BASEURL, FILEUPLOADURL } from '@API'

export default {
  name: 'KbFaultCaseEdit',
  setup() {
    const { commit, getters, dispatch } = useStore()
    const route = useRoute()
    const router = useRouter()
    const token = computed(() => getters.getToken)
    const { caseId } = route.query

    // 页面标题
    const pageTitle = ref(caseId ? '编辑典型案例' : '新建典型案例')

    // 故障分类下拉选项（不含"全部"）
    const classifyOptions = ref([
      { label: '硬件故障' },
      { label: '网络通讯' },
      { label: '数据库' },
      { label: '操作系统' },
      { label: '人为操作' }
    ])

    // 故障等级（参考 action.vue severityData）
    const severityData = ref([
      { label: '轻微' },
      { label: '一般' },
      { label: '严重' },
      { label: '灾难' }
    ])

    // 上传地址
    const uploadAction = ref(`${BASEURL}${FILEUPLOADURL}`)

    // 表单数据
    const caseFormRef = ref()
    const caseForm = reactive({
      faultTitle: '',
      firstClassify: '',
      faultLevel: '',
      targetDevice: '',
      faultTime: '',
      customTags: '',
      preBackground: '',
      scenePhenomenon: '',
      imgUrlList: [],
      checkThought: '',
      handleOperation: '',
      rootCause: '',
      preventPlan: '',
      fileUrlList: [],
      validStatus: '0'
    })

    // 表单校验规则
    const caseFormRules = {
      faultTitle: [{ required: true, message: '请输入故障标题', trigger: 'blur' }],
      firstClassify: [{ required: true, message: '请选择一级分类', trigger: 'change' }],
      faultLevel: [{ required: true, message: '请选择故障等级', trigger: 'change' }],
      targetDevice: [{ required: true, message: '请输入涉及设备/系统', trigger: 'blur' }],
      faultTime: [{ required: true, message: '请选择故障发生时间', trigger: 'change' }],
      scenePhenomenon: [{ required: true, message: '请输入故障现场现象', trigger: 'blur' }],
      checkThought: [{ required: true, message: '请输入分步排查思路', trigger: 'blur' }],
      handleOperation: [{ required: true, message: '请输入最终处置操作', trigger: 'blur' }],
      rootCause: [{ required: true, message: '请输入故障根本原因', trigger: 'blur' }]
    }

    // 图片上传成功
    const onImgSuccess = response => {
      if (response.data) {
        caseForm.imgUrlList = [...caseForm.imgUrlList, ...response.data]
      }
    }

    // 附件上传成功
    const onFileSuccess = response => {
      if (response.data) {
        caseForm.fileUrlList = [...caseForm.fileUrlList, ...response.data]
      }
    }

    // 获取详情数据
    const getCaseDetail = async () => {
      const res = await dispatch('fetchGetKbFaultCaseInfo', caseId)
      if (res && res.code === 200 && res.data) {
        const detail = res.data
        Object.keys(caseForm).forEach(key => {
          if (detail[key] !== undefined && detail[key] !== null) {
            caseForm[key] = detail[key]
          }
        })
        // 确保 imgUrlList 和 fileUrlList 是数组
        caseForm.imgUrlList = detail.imgUrlList || []
        caseForm.fileUrlList = detail.fileUrlList || []
      }
    }

    // 提交入库（校验必填项）
    const clickSubmit = () => {
      caseFormRef.value.CustomFormRef.validate()
        .then(() => {
          submitForm('1')
        })
        .catch(() => {})
    }

    // 保存为草稿（不校验）
    const clickSaveDraft = () => {
      submitForm('0')
    }

    // 统一提交
    const submitForm = validStatus => {
      const params = { ...caseForm, validStatus }
      if (caseId) {
        params.caseId = caseId
      }
      dispatch('fetchKbFaultCaseInsertOrUpdate', params).then(data => {
        if (data && data.code === 200) {
          commit('setError', {
            status: true,
            title: data.message,
            message: '正在返回列表...',
            type: 'success'
          })
          router.push({ path: '/kbFaultCase' })
        }
      })
    }

    // 返回列表
    const clickCancel = () => {
      router.push({ path: '/kbFaultCase' })
    }

    onMounted(() => {
      if (caseId) {
        getCaseDetail()
      }
    })

    return {
      pageTitle,
      classifyOptions,
      severityData,
      uploadAction,
      token,
      caseFormRef,
      caseForm,
      caseFormRules,
      onImgSuccess,
      onFileSuccess,
      clickSubmit,
      clickSaveDraft,
      clickCancel,
      tabberHeight
    }
  }
}
</script>

<style lang="scss">
.kb-fault-case-edit {
  @extend %params-global;
}
</style>
